module.exports = __webpack_public_path__ + "static/img/1-12.e4f06cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/1-12.png
// module id = AJng
// module chunks = 0